import './App.css';
import {Route, BrowserRouter, Routes} from "react-router-dom";
import {ThemeProvider, createTheme} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import SideMenu from "./components/SideMenu/SideMenu";
import Trade from "./pages/trade";
import Upload from "./pages/upload";
import Signup from "./pages/signup";
import Login from "./pages/login";
import MyItems from "./pages/my/MyItems";  // 새로 추가
import React from "react";
import {Helmet} from "react-helmet";
import GlobalSnackbar from './components/GlobalSnackbar';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline/>
      <Helmet>
        <title>Diablo Item Trading(AI)</title>
      </Helmet>
      <div className="App">
        <BrowserRouter>
          <SideMenu/>
          <Routes>
            <Route path="/trade" element={<Trade/>}/>
            <Route path="/upload" element={<Upload/>}/>
            <Route path="/login" element={<Login/>}/>
            <Route path="/signup" element={<Signup/>}/>
            <Route path="/my" element={<MyItems/>}/>
            <Route path="/" element={<Trade/>}/>
          </Routes>
        </BrowserRouter>
      </div>
      <GlobalSnackbar />
    </ThemeProvider>
  );
}

export default App;
